(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var container = document.querySelector('[data-product-recs]');
    if (!container) return;
    var productId = container.dataset.productId;
    var sectionId = container.dataset.sectionId;
    var limit = container.dataset.limit || 4;
    if (!productId || !sectionId) return;

    var url = '/recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var inner = doc.querySelector('.product-recs__inner');
        if (inner && inner.innerHTML.trim()) {
          container.querySelector('.product-recs__inner').innerHTML = inner.innerHTML;
        }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function init() {
      var dataEl = document.querySelector('.product-json');
      if (!dataEl) return;

    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var moneyFormat = data.moneyFormat;
    var selectedOptions = data.selectedOptions.slice();

    function formatMoney(cents, fmt) {
      var val = (cents / 100).toFixed(2);
      var noDecimals = String(Math.round(cents / 100));
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/g, val)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, val.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function updatePrice(variant) {
      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare-price]');
      var stickyPriceEl = document.querySelector('[data-sticky-price]');
      if (!priceEl || !variant) return;
      var formatted = formatMoney(variant.price, moneyFormat);
      priceEl.textContent = formatted;
      if (stickyPriceEl) stickyPriceEl.textContent = formatted;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.classList.add('product__price--sale');
        if (compareEl) {
          compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          compareEl.style.display = '';
        }
      } else {
        priceEl.classList.remove('product__price--sale');
        if (compareEl) compareEl.style.display = 'none';
      }
    }

    function updateButtons(variant) {
      var atcBtn = document.querySelector('[data-atc]');
      var stickyBtn = document.querySelector('[data-sticky-btn]');
      var available = variant && variant.available;
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? atcBtn.dataset.atcText : atcBtn.dataset.soldoutText;
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available;
        stickyBtn.textContent = available ? stickyBtn.dataset.atcText : stickyBtn.dataset.soldoutText;
      }
    }

    function updateVariantId(variant) {
      var input = document.querySelector('[data-variant-id]');
      if (input && variant) input.value = variant.id;
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var mediaId = String(variant.featured_media.id);
      document.querySelectorAll('.product__slide').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      });
      document.querySelectorAll('.product__thumb').forEach(function (thumb) {
        var active = thumb.dataset.mediaId === mediaId;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    }

    function onVariantChange() {
      var variant = findVariant();
      updatePrice(variant);
      updateButtons(variant);
      updateVariantId(variant);
      updateMedia(variant);
    }

    document.querySelectorAll('.product__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.dataset.mediaIndex;
        document.querySelectorAll('.product__slide').forEach(function (s) {
          s.classList.toggle('is-active', s.dataset.mediaIndex === idx);
        });
        document.querySelectorAll('.product__thumb').forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });

    document.querySelectorAll('.product__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var optIdx = parseInt(pill.dataset.option, 10);
        var value = pill.dataset.value;
        selectedOptions[optIdx] = value;
        var group = document.querySelector('[data-option-group="' + optIdx + '"]');
        if (group) {
          group.querySelectorAll('.product__pill').forEach(function (p) {
            p.classList.toggle('product__pill--selected', p.dataset.value === value);
          });
        }
        var display = document.querySelector('[data-option-display="' + optIdx + '"]');
        if (display) display.textContent = value;
        onVariantChange();
      });
    });

    document.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.product__qty-wrap');
        var input = wrap && wrap.querySelector('.product__qty-input');
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        input.value = btn.dataset.qty === 'minus' ? Math.max(1, val - 1) : val + 1;
      });
    });

    var atcBtn = document.querySelector('[data-atc]');
    var stickyBar = document.querySelector('[data-sticky-atc]');
    if (atcBtn && stickyBar) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting;
          stickyBar.classList.toggle('product-sticky-atc--visible', show);
          stickyBar.setAttribute('aria-hidden', String(!show));
        });
      }, { threshold: 0.5 });
      observer.observe(atcBtn);
    }

    var stickyBtn = document.querySelector('[data-sticky-btn]');
    if (stickyBtn && atcBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!atcBtn.disabled) atcBtn.click();
      });
    }

      updateMedia(findVariant());
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
